import React from "react";

const UtilityIcon = ({ width, height, color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="28"
        height="28"
        rx="3"
        fill="#F1F7FA"
        stroke="#064A72"
        strokeWidth="2"
      />
      <path
        d="M20.0899 5.81995C19.1702 5.06353 18.0933 4.52198 16.9376 4.23479C15.7819 3.94761 14.5767 3.92204 13.4099 4.15995C11.8563 4.47377 10.4309 5.24202 9.31462 6.36723C8.19832 7.49243 7.44141 8.92388 7.13994 10.4799C6.91979 11.6467 6.95979 12.8476 7.2571 13.9971C7.55441 15.1466 8.1017 16.2163 8.85994 17.1299C9.56363 17.924 9.96698 18.9395 9.99994 19.9999V22.9999C9.99994 23.7956 10.316 24.5587 10.8786 25.1213C11.4412 25.6839 12.2043 25.9999 12.9999 25.9999H16.9999C17.7956 25.9999 18.5587 25.6839 19.1213 25.1213C19.6839 24.5587 19.9999 23.7956 19.9999 22.9999V20.1899C20.0335 19.0191 20.4637 17.8944 21.2199 16.9999C22.5451 15.3607 23.1697 13.2648 22.9581 11.1676C22.7465 9.07038 21.7158 7.14143 20.0899 5.79995V5.81995ZM17.9999 22.9999C17.9999 23.2652 17.8946 23.5195 17.707 23.7071C17.5195 23.8946 17.2652 23.9999 16.9999 23.9999H12.9999C12.7347 23.9999 12.4804 23.8946 12.2928 23.7071C12.1053 23.5195 11.9999 23.2652 11.9999 22.9999V21.9999H17.9999V22.9999ZM19.6699 15.7599C18.6644 16.9525 18.0778 18.442 17.9999 19.9999H15.9999V16.9999C15.9999 16.7347 15.8946 16.4804 15.707 16.2928C15.5195 16.1053 15.2652 15.9999 14.9999 15.9999C14.7347 15.9999 14.4804 16.1053 14.2928 16.2928C14.1053 16.4804 13.9999 16.7347 13.9999 16.9999V19.9999H11.9999C11.9736 18.468 11.4069 16.9947 10.3999 15.8399C9.73558 15.0439 9.28883 14.0894 9.10325 13.0693C8.91767 12.0492 8.99959 10.9985 9.34103 10.0195C9.68247 9.04049 10.2718 8.16669 11.0515 7.48327C11.8312 6.79985 12.7747 6.33015 13.7899 6.11995C14.6625 5.94029 15.5641 5.95719 16.4293 6.16942C17.2945 6.38164 18.1016 6.78387 18.792 7.3469C19.4824 7.90993 20.0387 8.61962 20.4206 9.42446C20.8025 10.2293 21.0004 11.1091 20.9999 11.9999C21.0073 13.3698 20.537 14.6994 19.6699 15.7599Z"
        fill="black"
      />
    </svg>
  );
};

export default UtilityIcon;
